export default __webpack_public_path__ + "static/media/whyWeDoThis.74c71a21.png";